// 防止 global.js 被重复执行
if (!window.__GLOBAL_JS_LOADED__) {
window.__GLOBAL_JS_LOADED__ = true;
// 从 window.Shopify 获取 market handle
const marketHandle = window.Shopify && window.Shopify.marketHandle;
console.log("marketHandle:", marketHandle);
const globalEuPrefixRegex = /^\/(?:en|nl|de|es|fr|it)-eu(?=\/|$)/i;
const globalUkPrefixRegex = /^\/en-uk(?=\/|$)/i;

function isCaPrefixedPath(pathname) {
  return /^\/en-ca(?=\/|$)/i.test(String(pathname || ''));
}

function isEuPrefixedPath(pathname) {
  return globalEuPrefixRegex.test(String(pathname || ''));
}

function isUkPrefixedPath(pathname) {
  return globalUkPrefixRegex.test(String(pathname || ''));
}
/**
 * 自动补全页面链接的语言前缀脚本
 * 功能：监听页面所有 <a> 标签，自动根据当前 URL 补全语言/地区前缀
 */
(function () {
  // 匹配常见的 Shopify 语言/地区前缀格式，例如 /en-us, /fr-eu, /zh-TW, /fr, /de 等
  const prefixRegex = /^\/((?:en|nl|de|es|fr|it)-eu|en-[a-z]{2}|zh-TW|nl|de|es|fr|it|en)(?=\/|\?|#|$)/i;

  /**
   * 获取当前 URL 中的语言前缀
   * @returns {string} 如 "/en-us" 或 ""
   */
  function getCurrentPrefix() {
    const pathname = window.location && window.location.pathname ? window.location.pathname : '/';
    // Singapore uses the default storefront root, without a locale prefix.
    if (/^\/en-sg(?=\/|$)/i.test(pathname)) return '';
    const match = pathname.match(prefixRegex);
    return match ? `/${match[1]}` : '';
  }

  /**
   * 检查某个路径是否已经包含了前缀
   */
  function hasAnyPrefix(pathname) {
    return prefixRegex.test(pathname);
  }

  function normalizeRequestLanguage(value) {
    const raw = String(value || '').trim().toLowerCase().replace(/_/g, '-');
    if (!raw) return '';

    const supportedLanguages = ['en', 'de', 'fr', 'es', 'it', 'nl'];
    for (const language of supportedLanguages) {
      if (raw === language || raw.startsWith(`${language}-`)) return language;
    }

    return '';
  }

  function getRequestAcceptLanguage() {
    if (typeof window.getMarketCode === 'function' && window.getMarketCode() === 'ca') return 'CA';
    const sources = [];

    try {
      const currentPrefix = getCurrentPrefix();
      if (currentPrefix) sources.push(currentPrefix.slice(1));
    } catch (e) {}

    try {
      if (document && document.documentElement) {
        sources.push(document.documentElement.lang || '');
      }
    } catch (e) {}

    try {
      if (window.Shopify) {
        sources.push(window.Shopify.locale || '');
      }
    } catch (e) {}

    try {
      sources.push(navigator.language || '');
    } catch (e) {}

    for (const source of sources) {
      const normalized = normalizeRequestLanguage(source);
      if (normalized) return normalized;
    }

    return 'en';
  }

  /**
   * 规范化路径，确保以 "/" 开头
   */
  function normalizeRootRelative(path) {
    if (!path) return '';
    return path.startsWith('/') ? path : `/${path}`;
  }

  /**
   * 核心逻辑：给传入的路径加上当前站点的语言前缀
   * @param {string} path 原始路径
   */
  function withSitePrefix(path) {
    if (typeof path !== 'string' || path.length === 0) return path;
    if (!path.startsWith('/')) return path; // 忽略非根路径链接
    if (/^\/en-sg(?=\/|\?|#|$)/i.test(path)) {
      const unprefixed = path.replace(/^\/en-sg/i, '');
      return unprefixed.startsWith('/') ? unprefixed : '/' + unprefixed;
    }
    if (hasAnyPrefix(path)) return path;    // 如果已经有前缀了，跳过

    const prefix = getCurrentPrefix();
    if (!prefix) return path;               // 如果当前是默认语言（无前缀），跳过

    if (path === '/') return prefix || '/'; // 处理首页跳转
    return `${prefix}${path}`;              // 拼接前缀和路径
  }

  // 将方法挂载到 window，方便其他脚本调用
  window.withSitePrefix = withSitePrefix;
  window.getRequestAcceptLanguage = getRequestAcceptLanguage;

  function getLiveMarketCodeByUrl(hostname, pathname = window.location.pathname) {
    const host = String(hostname || '').toLowerCase();

    if ((host === 'strutt.inc' || host === 'www.strutt.inc') && isCaPrefixedPath(pathname)) return 'ca';
    if (host.includes('strutt.us')) return 'us';
    if (host.includes('uk.strutt.inc')) return 'uk';
    if (host.includes('eu.strutt.inc')) return 'eu';
    if (host.includes('strutt.inc') && !host.includes('uk.strutt.inc') && !host.includes('eu.strutt.inc')) return 'sg';

    return '';
  }

  function getTestMarketCodeByUrl(hostname, pathname) {
    const host = String(hostname || '').toLowerCase();
    const path = String(pathname || '').toLowerCase();
    const isEuLanguagePath = /^\/(?:nl|de|es|fr|it)(?=\/|$)/i.test(path);

    if (host.includes('gfhpc0-p9.myshopify.com') || path.startsWith('/en-us')) return 'us';
    if (host.includes('sy10cy-bd.myshopify.com') && isUkPrefixedPath(path)) return 'uk';
    if (host.includes('sy10cy-bd.myshopify.com') && (isEuPrefixedPath(path) || isEuLanguagePath)) return 'eu';
    if (host.includes('321eeeus.myshopify.com')) return isCaPrefixedPath(path) ? 'ca' : 'sg';

    return '';
  }

  window.getLiveMarketCodeByUrl = getLiveMarketCodeByUrl;
  window.getTestMarketCodeByUrl = getTestMarketCodeByUrl;


  function getMarketCode() {

    try {
      const host = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : '';
      const path = (window.location && window.location.pathname) ? window.location.pathname.toLowerCase() : '';

      const liveMarketCode = getLiveMarketCodeByUrl(host, path);
      if (liveMarketCode) return liveMarketCode;

      const testMarketCode = getTestMarketCodeByUrl(host, path);
      if (testMarketCode) return testMarketCode;

      const prefix = getCurrentPrefix();
      if (isCaPrefixedPath(prefix)) return 'ca';
      if (isUkPrefixedPath(prefix)) return 'uk';
      if (isEuPrefixedPath(prefix)) return 'eu';
    } catch (e) {}


    try {
      const labels = document.querySelectorAll('.component-navbar__region-label, .component-navbar__region-btn');
      let regionText = '';
      labels.forEach(btn => {
        if (regionText) return;
        if (!btn || !btn.textContent) return;
        const style = window.getComputedStyle(btn);
        if (style && style.display === 'none') return;
        regionText = btn.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
      });
      if (regionText === 'US') return 'us';
      if (regionText === 'UK') return 'uk';
      if (regionText === 'EU') return 'eu';
      if (regionText === 'SG') return 'sg';
      if (regionText === 'CA') return 'ca';
    } catch (e) {}

    return 'sg';
  }

  window.getMarketCode = getMarketCode;
  window.isUkMarket = function(market) { return market === 'uk'  };

  const ORDER_TRACKING_STORAGE_KEY = 'orderTrackingParams';
  const ORDER_TRACKING_ID_KEYS = ['gclid', 'fbclid', 'ttclid', 'msclkid'];

  function normalizeOrderTrackingParams(raw) {
    const result = {};
    if (!raw || typeof raw !== 'object') return result;

    Object.keys(raw).forEach((key) => {
      const normalizedKey = String(key || '').trim().toLowerCase();
      if (!normalizedKey) return;
      const isUtmKey = normalizedKey.indexOf('utm_') === 0;
      const isTrackingIdKey = ORDER_TRACKING_ID_KEYS.indexOf(normalizedKey) > -1;
      if (!isUtmKey && !isTrackingIdKey) return;

      const value = String(raw[key] || '').trim();
      if (!value) return;
      result[normalizedKey] = value;
    });

    return result;
  }

  function parseOrderTrackingParamsFromSearch(search) {
    const params = new URLSearchParams(search || '');
    const result = {};
    params.forEach((value, key) => {
      result[key] = value;
    });
    return normalizeOrderTrackingParams(result);
  }

  function readStoredOrderTrackingParams() {
    try {
      const raw = sessionStorage.getItem(ORDER_TRACKING_STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return normalizeOrderTrackingParams(parsed);
    } catch (e) {
      return {};
    }
  }

  function writeStoredOrderTrackingParams(params) {
    try {
      const normalized = normalizeOrderTrackingParams(params);
      if (!Object.keys(normalized).length) {
        sessionStorage.removeItem(ORDER_TRACKING_STORAGE_KEY);
        return normalized;
      }
      sessionStorage.setItem(ORDER_TRACKING_STORAGE_KEY, JSON.stringify(normalized));
      return normalized;
    } catch (e) {
      return normalizeOrderTrackingParams(params);
    }
  }

  function captureOrderTrackingParamsFromCurrentUrl() {
    const currentParams = parseOrderTrackingParamsFromSearch(window.location.search || '');
    const storedParams = readStoredOrderTrackingParams();
    const mergedParams = Object.assign({}, storedParams, currentParams);
    return writeStoredOrderTrackingParams(mergedParams);
  }

  function shouldAppendOrderTrackingParams(pathname) {
    const normalizedPath = normalizeRootRelative(pathname || '').toLowerCase();
    if (!normalizedPath) return false;
    return normalizedPath === '/pages/strutt-ev1'
      || normalizedPath.indexOf('/products/') === 0
      || normalizedPath === '/cart'
      || normalizedPath.indexOf('/cart/') === 0
      || normalizedPath === '/checkout';
  }

  function appendStoredOrderTrackingParamsToUrl(url) {
    if (typeof url !== 'string' || !url.trim()) return url;

    const storedParams = readStoredOrderTrackingParams();
    if (!Object.keys(storedParams).length) return url;

    try {
      const trimmedUrl = url.trim();
      const parsedUrl = new URL(trimmedUrl, window.location.origin);
      if (parsedUrl.origin !== window.location.origin) return url;
      if (!shouldAppendOrderTrackingParams(parsedUrl.pathname)) return url;

      Object.keys(storedParams).forEach((key) => {
        if (parsedUrl.searchParams.has(key)) return;
        parsedUrl.searchParams.set(key, storedParams[key]);
      });

      const isAbsoluteUrl = /^[a-z]+:\/\//i.test(trimmedUrl) || trimmedUrl.indexOf('//') === 0;
      return isAbsoluteUrl
        ? parsedUrl.toString()
        : parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (e) {
      return url;
    }
  }

  function decorateOrderTrackingLink(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    const href = String(anchor.getAttribute('href') || '').trim();
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
      return;
    }

    const nextHref = appendStoredOrderTrackingParamsToUrl(href);
    if (nextHref && nextHref !== href) {
      anchor.setAttribute('href', nextHref);
    }
  }

  function decorateOrderTrackingLinks(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach((anchor) => {
      decorateOrderTrackingLink(anchor);
    });
  }

  async function syncStoredOrderTrackingParamsToCartAttributes(extraAttributes) {
    const storedParams = readStoredOrderTrackingParams();
    const attributes = Object.assign({}, storedParams);

    if (extraAttributes && typeof extraAttributes === 'object') {
      Object.keys(extraAttributes).forEach((key) => {
        const normalizedKey = String(key || '').trim();
        const value = String(extraAttributes[key] || '').trim();
        if (!normalizedKey || !value) return;
        attributes[normalizedKey] = value;
      });
    }

    if (!Object.keys(attributes).length) return true;

    const cartUpdateUrl = window.withSitePrefix ? window.withSitePrefix('/cart/update.js') : '/cart/update.js';
    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ attributes })
    });

    return !!response.ok;
  }

  window.getStoredOrderTrackingParams = readStoredOrderTrackingParams;
  window.captureOrderTrackingParamsFromCurrentUrl = captureOrderTrackingParamsFromCurrentUrl;
  window.appendStoredTrackingParamsToUrl = appendStoredOrderTrackingParamsToUrl;
  window.syncStoredTrackingParamsToCartAttributes = syncStoredOrderTrackingParamsToCartAttributes;

  captureOrderTrackingParamsFromCurrentUrl();
  decorateOrderTrackingLinks(document);

  document.addEventListener('click', function(event) {
    const target = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!target) return;
    decorateOrderTrackingLink(target);
  }, true);

  if (typeof MutationObserver === 'function' && !window.__ORDER_TRACKING_LINK_OBSERVER__) {
    window.__ORDER_TRACKING_LINK_OBSERVER__ = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) {
            decorateOrderTrackingLink(node);
          }
          decorateOrderTrackingLinks(node);
        });
      });
    });

    const startObserve = () => {
      if (!document.body) return;
      window.__ORDER_TRACKING_LINK_OBSERVER__.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserve, { once: true });
    } else {
      startObserve();
    }
  }

  function parseWorkshopPaymentContext() {
    try {
      const raw = sessionStorage.getItem('takeDriveWorkshopPaymentContext');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      const reservationId = typeof parsed.reservationId === 'string' ? parsed.reservationId.trim() : String(parsed.reservationId || '').trim();
      const sessionIds = Array.isArray(parsed.sessionIds) ? parsed.sessionIds : [];
      const clientUuid = typeof parsed.clientUuid === 'string' ? parsed.clientUuid.trim() : String(parsed.clientUuid || '').trim();
      if (!reservationId) return null;
      return { reservationId, sessionIds, clientUuid };
    } catch (e) {
      return null;
    }
  }

  function isWorkshopPaymentProductPage() {
    try {
      const path = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
      return path.indexOf('/products/test30') > -1;
    } catch (e) {
      return false;
    }
  }

  function getVariantIdForWorkshopPayment() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    for (const form of forms) {
      const idInput = form.querySelector('input[name="id"]');
      const value = idInput ? String(idInput.value || '').trim() : '';
      if (value) return value;
    }
    const fallback = document.querySelector('input[name="id"]');
    return fallback ? String(fallback.value || '').trim() : '';
  }

  async function startWorkshopPaymentCheckout(context) {
    const variantId = getVariantIdForWorkshopPayment();
    if (!variantId) return false;

    const sessionIds = Array.isArray(context.sessionIds) ? context.sessionIds : [];
    const sessionIdValue = sessionIds.map((v) => String(v)).join(',');
    const clientUuid = typeof context.clientUuid === 'string' ? context.clientUuid : String(context.clientUuid || '');
    const attributes = {
      take_drive_reservation_id: String(context.reservationId || ''),
      take_drive_session_ids: sessionIdValue,
      take_drive_source: 'workshop',
      take_drive_client_uuid: clientUuid
    };
    const properties = {
      take_drive_reservation_id: String(context.reservationId || ''),
      take_drive_session_ids: sessionIdValue,
      take_drive_client_uuid: clientUuid
    };

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties })
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    try {
      sessionStorage.removeItem('takeDriveWorkshopPaymentContext');
    } catch (e) {}

    const checkoutUrl = window.withSitePrefix ? window.withSitePrefix('/checkout') : '/checkout';
    window.location.href = checkoutUrl;
    return true;
  }

  (function bindWorkshopPaymentFlow() {
    if (window.__TAKE_DRIVE_WORKSHOP_PAYMENT_BOUND__) return;
    window.__TAKE_DRIVE_WORKSHOP_PAYMENT_BOUND__ = true;

    const init = () => {
      if (!isWorkshopPaymentProductPage()) return;
      const context = parseWorkshopPaymentContext();
      if (!context) return;

      let inProgress = false;
      const triggerCheckout = async () => {
        if (inProgress) return;
        inProgress = true;

        const disableTargets = () => {
          const disabled = [];
          const targets = document.querySelectorAll('button, input[type="submit"]');
          targets.forEach((el) => {
            if (!el || el.disabled) return;
            el.disabled = true;
            el.setAttribute('aria-disabled', 'true');
            disabled.push(el);
          });
          return () => {
            disabled.forEach((el) => {
              if (!el) return;
              el.disabled = false;
              el.removeAttribute('aria-disabled');
            });
          };
        };

        let restoreTargets = null;
        try {
          restoreTargets = disableTargets();
          await startWorkshopPaymentCheckout(context);
        } catch (e) {
          if (restoreTargets) restoreTargets();
          inProgress = false;
        }
      };

      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (!form || !form.getAttribute) return;
          const action = String(form.getAttribute('action') || '');
          if (action.indexOf('/cart/add') === -1) return;
          event.preventDefault();
          triggerCheckout();
        },
        true
      );

      document.addEventListener(
        'click',
        (event) => {
          const target = event.target && event.target.closest
            ? event.target.closest('.shopify-payment-button__button, button[name="checkout"], [data-testid="Checkout-button"]')
            : null;
          if (!target) return;
          event.preventDefault();
          triggerCheckout();
        },
        true
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  // account/check 统一场景规则（不依赖 registeredSourceType）
  if (!window.__ACCOUNT_CHECK_RULES__) {
    window.__ACCOUNT_CHECK_RULES__ = true;
    window.AccountCheckMessages = {
      ACCOUNT_ERROR: "Can't find your account",
      ACCOUNT_LIMIT_LOGIN: 'This account cannot be logged into while its deletion is under review',
      ACCOUNT_NOT_ACTIVE: 'The account is not active',
      ACCOUNT_LIMIT_REGISTER: 'This account cannot be registered while its deletion is under review',
      ACCOUNT_ALREADY_EXISTS: 'This email is already registered, please try another email or go to login',
      ACCOUNT_NOT_ALLOW_KEEP_SAME: 'New email cannot be same as your current email',
      DEFAULT_ERROR: 'Please try again.'
    };

    window.getAccountCheckMessage = function(key) {
      return window.AccountCheckMessages[key] || window.AccountCheckMessages.DEFAULT_ERROR;
    };

    window.getAccountCheckBackendMessage = function(result) {
      const raw =
        (result && typeof result.message === 'string' && result.message) ||
        (result && typeof result.msg === 'string' && result.msg) ||
        (result && result.data && typeof result.data.message === 'string' && result.data.message) ||
        (result && result.data && typeof result.data.msg === 'string' && result.data.msg) ||
        '';
      const message = String(raw || '').trim();
      if (!message) return '';
      if (message.toLowerCase() === 'success') return '';
      return message;
    };

    window.parseAccountCheckData = function(result) {
      const data = result && result.data && typeof result.data === 'object' ? result.data : {};
      const isDeletedByStatus = Number(data.status) === 1;
      return {
        exists: data.exists === true,
        passwordSet: data.passwordSet === true,
        deleted: data.deleted === true || isDeletedByStatus 
      };
    };

    // 返回统一结构：{ allow, blocked, needActivate, message, state }
    window.resolveAccountCheck = function(scene, result) {
      const state = window.parseAccountCheckData(result);
      const backendMessage = window.getAccountCheckBackendMessage(result);
      const resolved = {
        allow: false,
        blocked: false,
        needActivate: false,
        message: '',
        state
      };

      if (scene === 'login') {
        if (state.deleted) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_LIMIT_LOGIN');
          return resolved;
        }
        if (!state.exists) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_ERROR');
          return resolved;
        }
        if (!state.passwordSet) {
          resolved.needActivate = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_NOT_ACTIVE');
          return resolved;
        }
        resolved.allow = true;
        return resolved;
      }

      if (scene === 'register') {
        if (state.deleted) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_LIMIT_REGISTER');
          return resolved;
        }
        if (state.exists) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_ALREADY_EXISTS');
          return resolved;
        }
        resolved.allow = true;
        return resolved;
      }

      if (scene === 'forgot') {
        if (state.deleted) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_LIMIT_LOGIN');
          return resolved;
        }
        if (!state.exists) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_ERROR');
          return resolved;
        }
        resolved.allow = true;
        return resolved;
      }

      if (scene === 'change-email') {
        if (state.deleted) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_LIMIT_REGISTER');
          return resolved;
        }
        if (state.exists) {
          resolved.blocked = true;
          resolved.message = backendMessage || window.getAccountCheckMessage('ACCOUNT_ALREADY_EXISTS');
          return resolved;
        }
        resolved.allow = true;
        return resolved;
      }

      resolved.allow = true;
      return resolved;
    };
  }

  /**
   * 获取预购商品的 handle
   * 逻辑与 snippets/get-preorder-product-handle.liquid 保持一致
   * @param {string} countryCode 可选，ISO 国家代码（如 'US', 'GB'）。如果不传，将尝试从 URL 前缀解析
   */
  window.getPreorderProductHandle = function(countryCode) {
    let code = countryCode;
    const hostname = window.location.hostname.toLowerCase();
    
    // 如果没有传入 countryCode，尝试从 URL 前缀获取
    if (!code) {
      const prefix = getCurrentPrefix(); // 例如 "/en-uk"
      if (prefix) {
        // 提取前缀中的国家部分，例如 "en-uk" -> "uk"
        const match = prefix.match(/^\/[a-z]{2}-([a-z]{2})$/i);
        if (match) {
          code = match[1];
        } else if (prefix === '/en') {
          // 特殊情况：如果是 /en，默认给个逻辑，或者保持为空
        }
      }
    }

    if (!code) {
      // 兜底方案：如果还是没拿到，尝试从全局变量读取（由 Liquid 在 theme.liquid 中注入）
      code = window.Shopify && window.Shopify.country ? window.Shopify.country : 'us';
    }

    code = code.toLowerCase();
    if (code === 'at') {
      code = 'eu';
    }

    if (hostname === 'strutt.inc' || hostname === 'www.strutt.inc' || hostname.indexOf('321eeeus.myshopify.com') !== -1) {
      return 'strutt-ev1c';
    }

    if (code !== 'us') {
      return `en-${code}-strutt-ev1`;
    } else {
      return 'strutt-ev1';
    }
  };

  /**
   * 过滤不需要处理的链接类型
   */
  function shouldSkipHref(href) {
    if (!href) return true;
    const trimmed = href.trim();
    if (!trimmed) return true;
    const lower = trimmed.toLowerCase();
    // 过滤锚点、邮件、电话和 JS 脚本
    if (lower.startsWith('#')) return true;
    if (lower.startsWith('mailto:')) return true;
    if (lower.startsWith('tel:')) return true;
    if (lower.startsWith('javascript:')) return true;
    return false;
  }

  /**
   * 重写单个 <a> 标签的 href 属性
   */
  function rewriteAnchorHref(anchor) {
    if (!anchor || anchor.nodeType !== 1) return;
    // 如果标签带有 data-no-prefix 或 data-skip-prefix 属性，则不处理
    if (anchor.hasAttribute('data-no-prefix') || anchor.hasAttribute('data-skip-prefix')) return;

    const rawHref = anchor.getAttribute('href');
    if (shouldSkipHref(rawHref)) return;

    const href = rawHref.trim();

    // 处理内部相对路径（如 "/products/..."）
    if (href.startsWith('/')) {
      const next = withSitePrefix(href);
      if (next && next !== href) {
        anchor.setAttribute('href', next);
      }
      return;
    }

    // 处理绝对路径（包含域名的情况）
    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//')) {
      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }

      // 只处理相同域名的链接，防止给外部链接加前缀
      if (url.origin !== window.location.origin) return;
      
      const nextPath = withSitePrefix(normalizeRootRelative(url.pathname));
      const next = `${nextPath}${url.search}${url.hash}`;
      const current = `${normalizeRootRelative(url.pathname)}${url.search}${url.hash}`;
      
      if (next !== current) {
        anchor.setAttribute('href', next);
      }
      return;
    }
  }

  /**
   * 遍历指定范围内的所有链接并重写
   */
  function rewriteAnchorsIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(rewriteAnchorHref);
  }

  /**
   * 关键功能：安装 DOM 观察器
   * 目的：处理动态加载的内容（如 AJAX 加载的商品、弹窗等）
   */
  function installDomObserver() {
    if (window.__prefixLinkObserverInstalled) return;
    window.__prefixLinkObserverInstalled = true;

    if (!window.MutationObserver) return;
    
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // 当页面有新的 DOM 节点插入时触发
        mutation.addedNodes && mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          // 如果新节点是 a 标签直接处理，否则检查其子元素
          if (node.matches && node.matches('a[href]')) {
            rewriteAnchorHref(node);
          } else {
            rewriteAnchorsIn(node);
          }
        });
      }
    });

    const start = () => {
      const target = document.body || document.documentElement;
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
      }
    };

    // 确保在 DOM 加载完成后启动观察
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  // 初始化入口
  function init() {
    // 之前用于处理跨市场跳转的 preferred_market cookie 逻辑已废弃，
    // 因为现在使用了独立的子域名 (uk.strutt.inc, eu.strutt.inc)，
    // Shopify 原生能够正确处理各个域名的路由，不再需要前端介入干预。

    const urlParams = new URLSearchParams(window.location.search);
    const countryParam = urlParams.get('country');
    if (countryParam) {
      // 清理 URL 参数，避免显示在地址栏
      history.replaceState(null, null, window.location.pathname);
    }

    const hostname = (window.location && window.location.hostname) ? window.location.hostname : '';
    const isTestEnv = hostname.includes('gfhpc0-p9.myshopify.com') || hostname.includes('321eeeus.myshopify.com') || hostname.includes('sy10cy-bd.myshopify.com');
    const isLocalhost = hostname.includes('localhost') || hostname === '127.0.0.1';
    
    // 配置正式环境各市场的基准 URL，方便后续一键切换新域名
    const PROD_HOSTS = {
      uk: 'https://uk.strutt.inc', // 'https://xpam1n-iz.myshopify.com/en-uk', // 后续切换为新域名时，改为 'https://uk.strutt.inc'
      eu: 'https://eu.strutt.inc', // 'https://xpam1n-iz.myshopify.com/en-eu', 后续切换为新域名时，改为 'https://eu.strutt.inc'
      sg: 'https://strutt.inc'
    };

    if (!isTestEnv && !isLocalhost) {
      const currentPath = window.location.pathname;
      const searchAndHash = window.location.search + window.location.hash;
      
      // 1. 拦截旧的 strutt.inc 上的市场链接，强制跳转到新地址
      // 避免旧链接访问 404
      if (hostname === 'strutt.inc') {
        if (isUkPrefixedPath(currentPath)) {
          let newPath = currentPath.replace(/^\/en-uk/, '') || '/';
          if (newPath === '/') newPath = '';
          window.location.href = `${PROD_HOSTS.uk}${newPath}${searchAndHash}`;
          return;
        } else if (isEuPrefixedPath(currentPath)) {
          let newPath = currentPath.replace(/^\/(?:en|nl|de|es|fr|it)-eu/i, '') || '/';
          if (newPath === '/') newPath = '';
          window.location.href = `${PROD_HOSTS.eu}${newPath}${searchAndHash}`;
          return;
        }
      }
    }

    rewriteAnchorsIn(document); // 先扫一遍现有页面的链接
    installDomObserver();      // 开启自动监听，处理未来出现的链接
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/**
 * 统一的数据验证和重定向机制
 * 用于检查必需的 sessionStorage、cookie、localStorage 数据
 * 如果缺失则重定向到登录页或指定页面
 */
window.requireData = function(requirements, options = {}) {
  const config = {
    redirectUrl: window.withSitePrefix(options.redirectUrl || '/pages/login'),
    onMissing: options.onMissing || null,  // 缺失时的回调函数
    showError: options.showError !== false, // 是否显示错误提示
    errorMessage: options.errorMessage || 'Required data is missing, please login again',
    excludePaths: options.excludePaths || ['/pages/login', '/pages/register'], // 排除的路径
    ...options
  };

  // 检查当前页面是否在排除列表中
  const currentPath = window.location.pathname;
  if (config.excludePaths.some(path => currentPath.includes(path))) {
    return { valid: true, missing: [] };
  }

  const missing = [];

  // 验证每个必需的数据项
  requirements.forEach(req => {
    const { 
      key,                    // 数据键名
      source = 'session',     // 数据源: 'session', 'cookie', 'local'
      required = true,        // 是否必需
      validator = null        // 自定义验证函数
    } = typeof req === 'string' ? { key: req } : req;

    if (!required) return;

    let value = null;

    // 根据数据源获取值
    try {
      switch (source) {
        case 'session':
          value = sessionStorage.getItem(key);
          break;
        case 'cookie':
          // 从 cookie 获取
          const cookies = document.cookie.split(';');
          for (let cookie of cookies) {
            const [name, val] = cookie.trim().split('=');
            if (name === key) {
              value = val || '';
              break;
            }
          }
          break;
        case 'local':
          value = localStorage.getItem(key);
          break;
      }
    } catch (e) {
      console.error(`Failed to get ${key} from ${source}:`, e);
    }

    // 验证数据
    const isValid = validator ? validator(value) : (value !== null && value !== '' && value !== 'null' && value !== 'undefined');

    if (!isValid) {
      missing.push({ key, source });
    }
  });

  // 如果有缺失的数据
  if (missing.length > 0) {
    console.warn('Required data missing:', missing);

    // 执行缺失回调
    if (config.onMissing) {
      config.onMissing(missing);
    }

    // 显示错误提示
    if (config.showError && window.showToast) {
      window.showToast(config.errorMessage, 'error', 2000);
    }

    // 延迟重定向，给错误提示显示时间
    setTimeout(() => {
      window.location.href = window.withSitePrefix ? window.withSitePrefix(config.redirectUrl) : config.redirectUrl;
    }, config.showError ? 1500 : 0);

    return { valid: false, missing };
  }

  return { valid: true, missing: [] };
};

/**
 * 页面加载时的数据验证（用于需要登录的页面）
 * @param {Array} requirements - 必需的数据列表
 * @param {Object} options - 配置选项
 */
window.requireAuth = function(requirements = [], options = {}) {
  // 默认检查 accessToken
  const defaultRequirements = [
    { key: 'accessToken', source: 'cookie', required: true }
  ];

  const allRequirements = [...defaultRequirements, ...requirements];
  
  return window.requireData(allRequirements, {
    redirectUrl: window.withSitePrefix('/pages/login'),
    errorMessage: 'Please login first',
    ...options
  });
};

/**
 * 流程数据验证（用于多步骤流程页面）
 * @param {Array} requirements - 必需的流程数据列表
 * @param {Object} options - 配置选项
 */
window.requireFlowData = function(requirements, options = {}) {
  return window.requireData(requirements, {
    redirectUrl: window.withSitePrefix(options.redirectUrl || '/pages/login'),
    errorMessage: options.errorMessage || 'Session expired, please start over',
    showError: true,
    ...options
  });
};

(function() {
  // 登录完成后统一根据 sessionStorage 的 checkout_url 重定向
  // 使用处：登录/密码页提交成功后的 onSuccess 回调可调用 redirectAfterLogin()
  window.redirectAfterLogin = function(fallbackUrl) {
    try {
      var checkoutUrl = sessionStorage.getItem('postLoginCheckoutUrl');
      if (checkoutUrl) {
        // 清理并跳转
        sessionStorage.removeItem('postLoginCheckoutUrl');
        window.location.href = window.withSitePrefix ? window.withSitePrefix(checkoutUrl) : checkoutUrl;
        return;
      }
    } catch (e) {}
    if (fallbackUrl) window.location.href = window.withSitePrefix ? window.withSitePrefix(fallbackUrl) : fallbackUrl;
  };
})();

 

window.routeByTransferDetail = async function(input) {
  try {
    var email = (input && input.email) || '';
    var orderName = (input && input.orderName) || '';
    if (!email) email = sessionStorage.getItem('verifyEmail') || sessionStorage.getItem('loginEmail') || '';
    if (!orderName) orderName = sessionStorage.getItem('orderName') || sessionStorage.getItem('currentOrderName') || '';
    if (!email || !orderName) return { ok: false, reason: 'missing_params' };

    sessionStorage.setItem('verifyEmail', email);
    sessionStorage.setItem('orderName', orderName);
    sessionStorage.setItem('currentOrderName', orderName);

    var baseURL = (input && input.baseURL) || (window.authAPI && window.authAPI.baseURL) || window.API_BASE_URL;
    var token = window.authAPI && window.authAPI.getAccessToken ? window.authAPI.getAccessToken() : '';
    var headers = { 'X-Client-Type': 'web' };
    headers['Accept-Language'] = window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en';
    if (token) headers['Authorization'] = 'Bearer ' + token;

    var query = 'email=' + encodeURIComponent(email) + '&orderName=' + encodeURIComponent(orderName);
    var url = baseURL.replace(/\/$/, '') + '/user/channel/transferDetail?' + query;
    var response = await fetch(url, { method: 'GET', headers: headers }).catch(function() { return null; });
    if (!response) return { ok: false, reason: 'network' };

    if (!response.ok && response.status === 404) {
      var urlFallback = baseURL.replace(/\/$/, '') + '/user/channel/transferDetail?' + query;
      response = await fetch(urlFallback, { method: 'GET', headers: headers }).catch(function() { return null; });
      if (!response) return { ok: false, reason: 'network' };
    }

    var result = await response.json().catch(function() { return null; });
    if (!result) return { ok: false, reason: 'bad_json' };
    var data = result && result.data && typeof result.data === 'object' ? result.data : result;
    var confirmValue = data && (data.confirm === true || data.confirm === 'true' || Number(data.confirm) === 1);

    var targetPath = confirmValue ? '/pages/balance-transfer-status' : '/pages/deposit-transfer';
    if (window.withSitePrefix) targetPath = window.withSitePrefix(targetPath);
    var targetUrl = new URL(targetPath, window.location.origin);
    targetUrl.searchParams.set('email', email);
    targetUrl.searchParams.set('orderName', orderName);
    if (confirmValue) {
      targetUrl.searchParams.set('status', 'transfer_confirmed');
    }
    window.location.replace(targetUrl.toString());
    return { ok: true, confirm: confirmValue };
  } catch (e) {
    return { ok: false, reason: 'exception' };
  }
};

// Toast 工具函数 - 完全兼容 component-toast 的功能和样式
window.showToast = function (message, type = 'normal', duration = 3000, icon = null, options = {}) {
  const localizedMessage = window.localizeFrontendText ? window.localizeFrontendText(message) : message;

  // 如果消息是"Operation completed successfully."，不显示
  if (
    localizedMessage === 'Operation completed successfully.' ||
    (window.getFrontendMessage && localizedMessage === window.getFrontendMessage('operationCompletedSuccessfully'))
  ) {
    return;
  }

  // 默认配置
  const config = {
    maxWidth: options.maxWidth || 250,           // 最大宽度，默认250px
    fontSize: options.fontSize || 16,            // 字体大小，默认16px
    autoWrap: options.autoWrap !== false,        // 自动换行，默认启用
    lineHeight: options.lineHeight || '150%',    // 行高，默认150%
    padding: options.padding || 16,              // 内边距，默认16px
    position: options.position || 'bottom',      // 位置：'top', 'center', 'bottom'
    ...options
  };
  // 移除现有的toast
  const existingToast = document.querySelector('.global-toast');
  if (existingToast) {
    existingToast.remove();
  }

  // 创建toast容器
  const toast = document.createElement('div');
  toast.className = 'global-toast component-toast';

  // 创建消息容器
  const messageContainer = document.createElement('div');
  messageContainer.className = 'component-toast__message';

  // 如果有图标，创建图标元素
  if (icon) {
    const iconElement = document.createElement('div');
    iconElement.className = 'component-toast__icon';
    iconElement.innerHTML = icon;
    toast.appendChild(iconElement);
  }

  // 设置消息内容，支持换行符
  if (localizedMessage.includes('\n')) {
    // 如果有换行符，分割文本并创建多个段落
    const lines = localizedMessage.split('\n');
    lines.forEach((line, index) => {
      if (line.trim()) { // 忽略空行
        const lineElement = document.createElement('div');
        lineElement.textContent = line;
        lineElement.style.marginBottom = index < lines.length - 1 ? '4px' : '0';
        messageContainer.appendChild(lineElement);
      }
    });
  } else {
    messageContainer.textContent = localizedMessage;
  }
  toast.appendChild(messageContainer);

  // 基础样式 - 完全匹配 component-toast.css
  const baseStyles = {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '9999',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    opacity: '0',
    visibility: 'hidden',
    transition: 'all 0.3s ease',
    minWidth: '180px',
    maxWidth: '90vw',
    boxSizing: 'border-box'
  };

  // 根据位置设置垂直位置
  switch (config.position) {
    case 'top':
      baseStyles.top = '24px';
      break;
    case 'center':
      baseStyles.top = '50%';
      baseStyles.transform = 'translate(-50%, -50%)';
      break;
    case 'bottom':
    default:
      baseStyles.bottom = '24px';
      break;
  }

  // 根据类型设置特定样式
  if (type === 'error') {
    Object.assign(baseStyles, {
      display: 'inline-flex',
      padding: config.padding + 'px',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      borderRadius: '12px',
      background: '#FFB4AB',
      width: config.maxWidth + 'px'
    });
  } else if (type === 'normal') {
    Object.assign(baseStyles, {
      background: '#2C2C33',
      width: config.maxWidth + 'px',
      padding: config.padding + 'px'
    });
  }

  // 应用基础样式
  Object.assign(toast.style, baseStyles);
  //TO DO 这里支持动态字体  font-size: var(--Body-B2, 16px);
  // 设置消息样式
  const messageStyles = {
    color: type === 'error' ? '#690B00' : '#FFFFFF',
    textAlign: 'center',
    fontFamily: '"STRUTT Modena 370"',
    fontSize: config.fontSize + 'px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: config.lineHeight,
    position: 'relative',
    alignSelf: 'stretch',
    wordWrap: config.autoWrap ? 'break-word' : 'normal',
    overflowWrap: config.autoWrap ? 'break-word' : 'normal',
    whiteSpace: config.autoWrap ? 'pre-wrap' : 'nowrap'
  };
  Object.assign(messageContainer.style, messageStyles);

  // 响应式设计
  if (window.innerWidth <= 480) {
    toast.style.minWidth = '160px';
    toast.style.maxWidth = 'calc(100vw - 32px)';

    // 根据位置调整移动端的位置
    if (config.position === 'bottom') {
      toast.style.bottom = 'calc(24px + env(safe-area-inset-bottom))';
    } else if (config.position === 'top') {
      toast.style.top = 'calc(24px + env(safe-area-inset-top))';
    }

    // 在移动设备上使用配置的宽度，但不超过屏幕宽度
    const mobileWidth = Math.min(config.maxWidth, window.innerWidth - 32);
    toast.style.width = mobileWidth + 'px';
  }

  // 添加到页面
  document.body.appendChild(toast);

  // 显示动画
  setTimeout(() => {
    toast.style.opacity = '1';
    toast.style.visibility = 'visible';
  }, 10);

  // 自动隐藏
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.visibility = 'hidden';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }, duration);
};

// 隐藏toast的函数
window.hideToast = function () {
  const toast = document.querySelector('.global-toast');
  if (toast) {
    toast.style.opacity = '0';
    toast.style.visibility = 'hidden';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }
};

// 通用错误信息显示函数
window.showError = function (message, container = null, options = {}) {
  const localizedMessage = window.localizeFrontendText ? window.localizeFrontendText(message) : message;

  // 默认配置 - 符合设计规范
  const config = {
    className: options.className || 'global-error',
    marginTop: options.marginTop || '4px',
    marginLeft: options.marginLeft || '16px',
    inputId: options.inputId || null,        // 输入框的ID
    inputClass: options.inputClass || null,  // 输入框的类名
    errorClass: options.errorClass || 'component-text-input__field--error', // 错误样式类名
    // 文本样式配置 - 使用 STRUTT Modena 370 字体
    color: options.color || 'var(--function-error, #FFB4AB)',
    fontFamily: options.fontFamily || '"STRUTT Modena 370"',
    fontSize: options.fontSize || 'var(--Caption-C1_fixed, 14px)',
    fontStyle: options.fontStyle || 'normal',
    fontWeight: options.fontWeight || '300',
    lineHeight: options.lineHeight || '150%', // 21px
    // 内容展示配置
    useHTML: options.useHTML || false,  // 是否支持 HTML 内容
    formatNewlines: options.formatNewlines || false,  // 是否格式化换行符
    ...options
  };

  // 移除现有的错误信息
  const existingError = document.querySelector('.' + config.className);
  if (existingError) {
    existingError.remove();
  }

  // 创建错误信息元素
  const errorDiv = document.createElement('div');
  errorDiv.className = config.className;

  const errorContent = document.createElement('div');
  errorContent.className = 'global-error__content component-input__error-text';
  errorContent.style.display = 'block';
  errorContent.style.width = '100%';

  // 处理展示内容
  if (config.useHTML) {
    // 支持 HTML 内容
    errorContent.innerHTML = localizedMessage;
  } else if (config.formatNewlines && localizedMessage.includes('\n')) {
    // 使用 pre-line 保持换行，避免额外子节点影响高度计算
    errorContent.textContent = localizedMessage;
    errorContent.style.whiteSpace = 'pre-line';
  } else {
    // 纯文本
    errorContent.textContent = localizedMessage;
  }

  errorDiv.appendChild(errorContent);

  // 应用样式
  const errorStyles = {
    color: config.color,
    fontFamily: config.fontFamily,
    fontSize: config.fontSize,
    fontStyle: config.fontStyle,
    fontWeight: config.fontWeight,
    lineHeight: config.lineHeight,
    marginTop: config.marginTop,
    marginLeft: config.marginLeft,
    textAlign: config.textAlign || 'left',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    minHeight: '30px'
  };
  Object.assign(errorDiv.style, errorStyles);

  // 插入到指定容器或默认位置
  if (container) {
    // 如果提供了容器，插入到容器中
    container.appendChild(errorDiv);
  } else {
    // 默认插入到 body 中
    document.body.appendChild(errorDiv);
  }

  applyPresetErrorHeight(errorDiv, errorContent);

  // 自动为对应的输入框添加错误样式
  let inputElement = null;

  // 优先通过ID查找输入框
  if (config.inputId) {
    inputElement = document.getElementById(config.inputId);
  }

  // 如果ID没找到，尝试通过类名查找
  if (!inputElement && config.inputClass) {
    inputElement = document.querySelector('.' + config.inputClass);
  }

  // 如果找到了输入框，添加错误样式
  if (inputElement) {
    inputElement.classList.add(config.errorClass);
  }

  return errorDiv;
};

// 简化的错误信息显示函数 - 只需要 message 和 container
window.showSimpleError = function (message, container) {
  return window.showError(message, container, {
    className: 'simple-error',
    marginTop: '4px',
    marginLeft: '16px',
    color: 'var(--function-error, #FFB4AB)',
    fontFamily: '"STRUTT Modena 370"',
    fontSize: 'var(--Caption-C1_fixed, 14px)',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '150%'
  });
};

// 隐藏错误信息的函数
window.hideError = function (className = 'global-error', inputId = null, inputClass = null, errorClass = 'component-text-input__field--error', containerSelector = null) {
  let errorDiv = null;

  // 如果指定了容器，在容器中查找错误元素
  if (containerSelector) {
    const container = document.querySelector(containerSelector);
    if (container) {
      errorDiv = container.querySelector('.' + className);
    }
  }

  // 如果没有找到或没有指定容器，在全局查找
  if (!errorDiv) {
    errorDiv = document.querySelector('.' + className);
  }

  if (errorDiv) {
    errorDiv.remove();
  }

  // 自动移除对应输入框的错误样式
  let inputElement = null;

  // 优先通过ID查找输入框
  if (inputId) {
    inputElement = document.getElementById(inputId);
  }

  // 如果ID没找到，尝试通过类名查找
  if (!inputElement && inputClass) {
    inputElement = document.querySelector('.' + inputClass);
  }

  // 如果找到了输入框，移除错误样式
  if (inputElement) {
    inputElement.classList.remove(errorClass);
  }
};

// 隐藏简单错误信息的函数
window.hideSimpleError = function () {
  window.hideError('simple-error');
};

// ============================================
// Login entry guard (shared by login workflows)
// ============================================
(function () {
  function hasAccessTokenFromCookie() {
    try {
      const cookieToken = document.cookie
        .split(';')
        .map(item => item.trim())
        .find(item => item.startsWith('accessToken='));
      return !!(cookieToken && cookieToken.split('=').slice(1).join('='));
    } catch (err) {
      return false;
    }
  }

  function isUserLoggedIn() {
    try {
      if (window.authAPI && typeof window.authAPI.isLoggedIn === 'function') {
        return !!window.authAPI.isLoggedIn();
      }
      return hasAccessTokenFromCookie();
    } catch (error) {
      return hasAccessTokenFromCookie();
    }
  }

  function resolveLoginRedirectTarget(options) {
    const mobileBreakpoint = Number.isFinite(options.mobileBreakpoint)
      ? options.mobileBreakpoint
      : 734;
    const isMobile = window.innerWidth <= mobileBreakpoint;
    if (typeof options.resolveTarget === 'function') {
      return options.resolveTarget({ isMobile, mobileBreakpoint });
    }
    const mobileTarget = window.withSitePrefix ? window.withSitePrefix(options.mobileTarget || '/pages/mobile-menu') : options.mobileTarget || '/pages/mobile-menu';
    const desktopTarget = window.withSitePrefix ? window.withSitePrefix(options.desktopTarget || '/pages/my-account') : options.desktopTarget || '/pages/my-account';
    return isMobile ? mobileTarget : desktopTarget;
  }

  window.setupLoginEntryGuard = function setupLoginEntryGuard(options = {}) {
    if (typeof window === 'undefined') {
      return { check: () => {}, destroy: () => {} };
    }

    const delayOnHistory = Number.isFinite(options.historyDelay) ? options.historyDelay : 100;
    const delayOnVisibility = Number.isFinite(options.visibilityDelay) ? options.visibilityDelay : 100;
    const runOnLoad = options.runOnLoad !== false;
    const enablePageShow = options.enablePageShow !== false;
    const enableVisibilityChange = options.enableVisibilityChange !== false;

    const shouldRedirect = typeof options.shouldRedirect === 'function'
      ? options.shouldRedirect
      : () => true;

    const performRedirect = typeof options.onRedirect === 'function'
      ? options.onRedirect
      : (target) => {
        if (typeof target === 'string' && target.length > 0) {
          window.location.href = window.withSitePrefix ? window.withSitePrefix(target) : target;
        }
      };

    const check = () => {
      if (!isUserLoggedIn()) {
        return;
      }
      if (!shouldRedirect()) {
        return;
      }
      const target = resolveLoginRedirectTarget(options);
      performRedirect(target);
    };

    function handleDomReady() {
      document.removeEventListener('DOMContentLoaded', handleDomReady);
      check();
    }

    if (runOnLoad) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleDomReady);
      } else {
        check();
      }
    }

    function handlePageShow(event) {
      const navigationEntries = typeof performance !== 'undefined' && performance.getEntriesByType
        ? performance.getEntriesByType('navigation')
        : [];
      const navEntry = navigationEntries && navigationEntries.length ? navigationEntries[0] : null;
      const fromHistory = (event && event.persisted === true) ||
        (navEntry && navEntry.type === 'back_forward');
      if (fromHistory) {
        setTimeout(check, delayOnHistory);
      }
    }

    if (enablePageShow) {
      window.addEventListener('pageshow', handlePageShow);
    }

    function handleVisibilityChange() {
      if (!document.hidden) {
        setTimeout(check, delayOnVisibility);
      }
    }

    if (enableVisibilityChange) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return {
      check,
      destroy() {
        document.removeEventListener('DOMContentLoaded', handleDomReady);
        if (enablePageShow) {
          window.removeEventListener('pageshow', handlePageShow);
        }
        if (enableVisibilityChange) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
      }
    };
  };
})();

// 通用函数：显示输入框的错误信息（支持 text-input 和 password-input）
function getActiveLayout() {
  const isMobile = window.innerWidth <= 734;
  return document.querySelector(isMobile ? '.root-mobile-layout' : '.root-desktop-layout') ||
    document.querySelector('.responsive-layout') ||
    document;
}

function resolveInputElement(targetOrSelector) {
  if (!targetOrSelector) {
    return null;
  }

  const isDomElement = (!!targetOrSelector && typeof targetOrSelector === 'object') &&
    (
      (typeof Element !== 'undefined' && targetOrSelector instanceof Element) ||
      targetOrSelector.nodeType === 1
    );

  if (isDomElement) {
    return targetOrSelector;
  }

  if (typeof targetOrSelector === 'string') {
    const layout = getActiveLayout();
    if (!layout) {
      return null;
    }
    return layout.querySelector(targetOrSelector);
  }

  return null;
}

function syncFormInputErrorState(component) {
  const scope = component?.closest('form, [data-error-spacing-scope]');
  if (!scope) {
    return;
  }

  const hasVisibleInputError = !!scope.querySelector(
    '.component-text-input--has-visible-error, .component-password-input--has-visible-error'
  );
  scope.classList.toggle('form--has-visible-input-error', hasVisibleInputError);
}

window.syncFormInputErrorState = syncFormInputErrorState;

function getPresetErrorHeight(lineCount) {
  if (lineCount >= 3) {
    return '76px';
  }

  if (lineCount === 2) {
    return '52px';
  }

  return '30px';
}

function applyPresetErrorHeight(errorContainer, contentElement) {
  if (!errorContainer || !contentElement) {
    return;
  }

  requestAnimationFrame(() => {
    const computedStyle = window.getComputedStyle(contentElement);
    const lineHeight = parseFloat(computedStyle.lineHeight) || 21;
    const textHeight = contentElement.getBoundingClientRect().height;
    const lineCount = Math.max(1, Math.round(textHeight / lineHeight));

    errorContainer.style.minHeight = getPresetErrorHeight(lineCount);
  });
}

function ensureInputErrorTextNode(errorContainer) {
  if (!errorContainer) {
    return null;
  }

  let textNode = errorContainer.querySelector('.component-input__error-text');
  if (!textNode) {
    textNode = document.createElement('span');
    textNode.className = 'component-input__error-text';
    textNode.textContent = errorContainer.textContent.trim();
    errorContainer.textContent = '';
    errorContainer.appendChild(textNode);
  }

  return textNode;
}

function syncInputErrorLineState(errorContainer) {
  if (!errorContainer) {
    return;
  }

  const textNode = ensureInputErrorTextNode(errorContainer);
  if (!textNode) {
    return;
  }

  const message = textNode.textContent.trim();
  const singleLineClass = 'component-input__error--single-line';
  const twoLinesClass = 'component-input__error--two-lines';
  const threeLinesClass = 'component-input__error--three-lines';

  errorContainer.classList.remove(singleLineClass, twoLinesClass, threeLinesClass);

  if (!message) {
    return;
  }

  requestAnimationFrame(() => {
    const lineHeight = parseFloat(window.getComputedStyle(errorContainer).lineHeight) || 21;
    const textHeight = textNode.getBoundingClientRect().height;
    const lines = Math.max(1, Math.round(textHeight / lineHeight));
    errorContainer.style.minHeight = getPresetErrorHeight(lines);

    errorContainer.classList.remove(singleLineClass, twoLinesClass, threeLinesClass);

    if (lines >= 3) {
      errorContainer.classList.add(threeLinesClass);
    } else if (lines === 2) {
      errorContainer.classList.add(twoLinesClass);
    } else {
      errorContainer.classList.add(singleLineClass);
    }
  });
}

function setInputErrorMessage(errorContainer, message) {
  if (!errorContainer) {
    return;
  }

  const textNode = ensureInputErrorTextNode(errorContainer);
  if (!textNode) {
    return;
  }

  textNode.textContent = message || '';
  syncInputErrorLineState(errorContainer);
}

function clearInputErrorMessage(errorContainer) {
  if (!errorContainer) {
    return;
  }

  const textNode = errorContainer.querySelector('.component-input__error-text');
  if (textNode) {
    textNode.textContent = '';
  } else {
    errorContainer.textContent = '';
  }

  errorContainer.classList.remove(
    'component-input__error--single-line',
    'component-input__error--two-lines',
    'component-input__error--three-lines'
  );
  errorContainer.style.removeProperty('min-height');
}

window.syncInputErrorLineState = syncInputErrorLineState;
window.setInputErrorMessage = setInputErrorMessage;
window.clearInputErrorMessage = clearInputErrorMessage;

window.showTextInputError = function (message, inputTarget = 'input[data-intended-type="email"]') {
  const localizedMessage = window.localizeFrontendText ? window.localizeFrontendText(message) : message;
  const inputElement = resolveInputElement(inputTarget);
  if (!inputElement) {
    return;
  }

  // 确定组件类型和相应的选择器
  const textInputComponent = inputElement.closest('.component-text-input');
  const passwordInputComponent = inputElement.closest('.component-password-input');

  let component = textInputComponent || passwordInputComponent;
  let errorContainer = null;
  let errorIcon = null;
  let errorClass = '';
  let componentErrorClass = '';
  let visibleErrorStateClass = '';

  if (textInputComponent) {
    // 处理 text-input 组件
    errorContainer = textInputComponent.querySelector('.component-text-input__error');
    errorIcon = textInputComponent.querySelector('.component-text-input__error-icon');
    errorClass = 'component-text-input__field--error';
    componentErrorClass = 'component-text-input--error';
    visibleErrorStateClass = 'component-text-input--has-visible-error';
  } else if (passwordInputComponent) {
    // 处理 password-input 组件
    errorContainer = passwordInputComponent.querySelector('.component-password-input__error');
    errorIcon = passwordInputComponent.querySelector('.component-password-input__error-icon');
    errorClass = 'component-password-input__field--error';
    componentErrorClass = 'component-password-input--error';
    visibleErrorStateClass = 'component-password-input--has-visible-error';
  }



  if (errorContainer) {
    // 设置错误信息内容
    if (window.setInputErrorMessage) {
      window.setInputErrorMessage(errorContainer, localizedMessage);
    } else {
      errorContainer.textContent = localizedMessage;
    }
    // 显示错误容器
    errorContainer.style.display = 'flex';

    // 添加错误样式到输入框
    inputElement.classList.add(errorClass);
    if (inputElement.dataset && inputElement.dataset.allowErrorOnFocus === 'true') {
      inputElement.dataset.errorPriorityActive = 'true';
    }

    // 添加错误样式到组件
    if (component) {
      component.classList.add(componentErrorClass);
      component.classList.add(visibleErrorStateClass);
    }

    // 显示错误图标
    if (errorIcon) {
      errorIcon.style.display = 'flex';
    }

    // 当存在动态清除按钮或密码切换按钮时，确保错误优先展示
    const clearBtn = component?.querySelector('.component-text-input__clear-btn');
    if (clearBtn) {
      clearBtn.style.display = 'none';
    }
    const passwordToggle = component?.querySelector('.component-text-input__password-toggle');
    if (passwordToggle) {
      passwordToggle.style.display = 'none';
    }

    syncFormInputErrorState(component);
  }
};

// 通用函数：隐藏输入框的错误信息（支持 text-input 和 password-input）
window.hideTextInputError = function (inputTarget = 'input[data-intended-type="email"]') {
  const inputElement = resolveInputElement(inputTarget);
  if (!inputElement) {
    return;
  }

  // 确定组件类型和相应的选择器
  const textInputComponent = inputElement.closest('.component-text-input');
  const passwordInputComponent = inputElement.closest('.component-password-input');

  let component = textInputComponent || passwordInputComponent;
  let errorContainer = null;
  let errorIcon = null;
  let errorClass = '';
  let componentErrorClass = '';
  let visibleErrorStateClass = '';

  if (textInputComponent) {
    // 处理 text-input 组件
    errorContainer = textInputComponent.querySelector('.component-text-input__error');
    errorIcon = textInputComponent.querySelector('.component-text-input__error-icon');
    errorClass = 'component-text-input__field--error';
    componentErrorClass = 'component-text-input--error';
    visibleErrorStateClass = 'component-text-input--has-visible-error';
  } else if (passwordInputComponent) {
    // 处理 password-input 组件
    errorContainer = passwordInputComponent.querySelector('.component-password-input__error');
    errorIcon = passwordInputComponent.querySelector('.component-password-input__error-icon');
    errorClass = 'component-password-input__field--error';
    componentErrorClass = 'component-password-input--error';
    visibleErrorStateClass = 'component-password-input--has-visible-error';
  }

  if (errorContainer) {
    // 隐藏错误容器
    errorContainer.style.display = 'none';
    // 清空错误信息
    if (window.clearInputErrorMessage) {
      window.clearInputErrorMessage(errorContainer);
    } else {
      errorContainer.textContent = '';
    }

    // 移除错误样式
    inputElement.classList.remove(errorClass);
    if (inputElement.dataset && inputElement.dataset.errorPriorityActive) {
      delete inputElement.dataset.errorPriorityActive;
    }

    if (component) {
      component.classList.remove(componentErrorClass);
      component.classList.remove(visibleErrorStateClass);
    }

    // 隐藏错误图标
    if (errorIcon) {
      errorIcon.style.display = 'none';
    }

    syncFormInputErrorState(component);
  }
};

// 全局输入框错误显示函数
window.showInputError = function (message, options = {}) {
  const config = {
    // 错误容器相关
    errorContainerId: options.errorContainerId || null,
    errorContainerSelector: options.errorContainerSelector || null,

    // 输入框相关
    inputSelector: options.inputSelector || '.component-text-input__field',
    inputClass: options.inputClass || 'component-text-input__field',
    errorClass: options.errorClass || 'component-text-input__field--error',

    // 错误信息相关
    className: options.className || 'global-error',
    marginLeft: options.marginLeft || '0px',

    // 布局相关
    mobileBreakpoint: options.mobileBreakpoint || 734,
    mobileLayoutSelector: options.mobileLayoutSelector || '.root-mobile-layout',
    desktopLayoutSelector: options.desktopLayoutSelector || '.root-desktop-layout',

    ...options
  };

  if (!window.showError) {
    return;
  }

  // 查找当前可见的布局容器
  const isMobile = window.innerWidth <= config.mobileBreakpoint;
  const targetLayout = isMobile ?
    document.querySelector(config.mobileLayoutSelector) :
    document.querySelector(config.desktopLayoutSelector);


  // 确保我们有一个有效的容器
  let errorContainer = document.body; // 默认使用 body

  if (targetLayout) {
    // 优先使用指定的错误容器ID
    if (config.errorContainerId) {
      const foundContainer = targetLayout.querySelector(`#${config.errorContainerId}`);
      if (foundContainer) {
        errorContainer = foundContainer;
      }
    }
    // 其次使用指定的错误容器选择器
    else if (config.errorContainerSelector) {
      const foundContainer = targetLayout.querySelector(config.errorContainerSelector);
      if (foundContainer) {
        errorContainer = foundContainer;
      }
    }
  }


  // 检查输入框是否存在
  const inputElement = document.querySelector(config.inputSelector);

  // 调用全局 showError 函数
  window.showError(message, errorContainer, {
    className: config.className,
    marginLeft: config.marginLeft,
    inputClass: config.inputClass,
    errorClass: config.errorClass
  });

  // 手动确保组件显示错误状态
  if (inputElement) {
    // 为输入框添加错误类
    inputElement.classList.add(config.errorClass);

    // 为整个组件添加错误状态
    const textInputComponent = inputElement.closest('.component-text-input');
    if (textInputComponent) {
      textInputComponent.classList.add('component-text-input--error');

      // 手动显示错误图标
      const errorIcon = textInputComponent.querySelector('.component-text-input__error-icon');
      if (errorIcon) {
        errorIcon.style.display = 'flex';
      } else {
      }
    }
  }

  // 检查错误样式是否被添加
  setTimeout(() => {
    const inputAfter = document.querySelector(config.inputSelector);
    const componentAfter = inputAfter?.closest('.component-text-input');
  }, 100);
};

// 全局输入框错误隐藏函数
window.hideInputError = function (options = {}) {
  const config = {
    // 错误信息相关
    className: options.className || 'global-error',

    // 输入框相关
    inputSelector: options.inputSelector || '.component-text-input__field',
    inputClass: options.inputClass || 'component-text-input__field',
    errorClass: options.errorClass || 'component-text-input__field--error',

    ...options
  };


  // 使用全局 hideError 函数
  window.hideError(config.className, null, config.inputClass, config.errorClass);

  // 手动清除组件的错误状态
  const inputElement = document.querySelector(config.inputSelector);
  if (inputElement) {
    // 移除输入框的错误类
    inputElement.classList.remove(config.errorClass);

    // 移除整个组件的错误状态
    const textInputComponent = inputElement.closest('.component-text-input');
    if (textInputComponent) {
      textInputComponent.classList.remove('component-text-input--error');

      // 手动隐藏错误图标
      const errorIcon = textInputComponent.querySelector('.component-text-input__error-icon');
      if (errorIcon) {
        errorIcon.style.display = 'none';
      }
    }
  }
};

// 数字键盘检测函数
function detectKeyboard() {
  // 检查是否支持 visualViewport API
  if (window.visualViewport) {
    const viewport = window.visualViewport;

    // 监听视口变化
    viewport.addEventListener('resize', function () {
      const isKeyboardActive = viewport.height < window.innerHeight * 0.8;

      // 找到所有 fixed-bottom-button 元素
      const fixedButtons = document.querySelectorAll('.fixed-bottom-button');

      fixedButtons.forEach(button => {
        if (isKeyboardActive) {
          button.classList.add('keyboard-active');
        } else {
          button.classList.remove('keyboard-active');
        }
      });

      // 同时更新页面内容区域
      const pageContents = document.querySelectorAll('[class*="-page__content"]');
      pageContents.forEach(content => {
        if (isKeyboardActive) {
          content.classList.add('keyboard-active');
        } else {
          content.classList.remove('keyboard-active');
        }
      });

    });

    // 初始检查
    const initialKeyboardActive = viewport.height < window.innerHeight * 0.8;
    if (initialKeyboardActive) {
      document.querySelectorAll('.fixed-bottom-button').forEach(button => {
        button.classList.add('keyboard-active');
      });
    }
  } else {
    // 降级方案：使用 resize 事件
    let initialHeight = window.innerHeight;

    window.addEventListener('resize', function () {
      const currentHeight = window.innerHeight;
      const heightDifference = initialHeight - currentHeight;

      // 如果高度减少超过150px，认为是键盘激活
      const isKeyboardActive = heightDifference > 150;

      document.querySelectorAll('.fixed-bottom-button').forEach(button => {
        if (isKeyboardActive) {
          button.classList.add('keyboard-active');
        } else {
          button.classList.remove('keyboard-active');
        }
      });

      // 更新页面内容区域
      document.querySelectorAll('[class*="-page__content"]').forEach(content => {
        if (isKeyboardActive) {
          content.classList.add('keyboard-active');
        } else {
          content.classList.remove('keyboard-active');
        }
      });

    });
  }
}

// 页面加载完成后初始化键盘检测
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', detectKeyboard);
} else {
  detectKeyboard();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    if (!this.input) return;
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (!this.input) return;
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const clickedButton = event.target?.closest ? event.target.closest('button') : null;
    if (!clickedButton || clickedButton.disabled) return;

    const buttonName = clickedButton?.getAttribute('name') || event.target?.getAttribute?.('name') || event.target?.name;

    const rawValue = Number.parseInt(this.input.value, 10);
    const inputMinAttr = this.input.getAttribute('min');
    const inputMaxAttr = this.input.getAttribute('max');
    const inputStepAttr = this.input.getAttribute('step');

    const min = Number.isFinite(Number.parseInt(inputMinAttr, 10))
      ? Number.parseInt(inputMinAttr, 10)
      : Number.parseInt(this.input.dataset.min, 10) || 0;
    const max =
      inputMaxAttr != null && inputMaxAttr !== '' && Number.isFinite(Number.parseInt(inputMaxAttr, 10))
        ? Number.parseInt(inputMaxAttr, 10)
        : Number.POSITIVE_INFINITY;
    const step = Number.parseInt(inputStepAttr, 10) || 1;

    let nextValue = Number.isFinite(rawValue) ? rawValue : min;

    if (buttonName === 'plus') {
      if (Number.parseInt(this.input.dataset.min, 10) > step && nextValue === 0) {
        nextValue = Number.parseInt(this.input.dataset.min, 10);
      } else {
        nextValue += step;
      }
    } else if (buttonName === 'minus') {
      nextValue -= step;
    }

    if (!Number.isFinite(nextValue)) nextValue = min;
    nextValue = Math.max(min, Math.min(max, nextValue));

    const previousValue = this.input.value;
    const nextValueString = String(nextValue);
    if (previousValue !== nextValueString) {
      this.input.value = nextValueString;
      this.input.dispatchEvent(this.changeEvent);
    }

    this.validateQtyRules();
  }

  validateQtyRules() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (!buttonMinus) return;
      const isDisabled = parseInt(value) <= parseInt(this.input.min);
      buttonMinus.classList.toggle('disabled', isDisabled);
      buttonMinus.disabled = isDisabled;
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (!buttonPlus) return;
      const isDisabled = value >= max;
      buttonPlus.classList.toggle('disabled', isDisabled);
      buttonPlus.disabled = isDisabled;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const closeButton = this.querySelector('[id^="ModalClose-"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.hide.bind(this, false));
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    if (this.contains(document.activeElement)) document.activeElement.blur();
    this.removeAttribute('open');
    removeTrapFocus();
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const target = event && event.target;
    if (!target || target.tagName !== 'INPUT' || target.type !== 'number') return;
    if (!target.classList.contains('quantity__input') && !target.classList.contains('cart-quantity-input')) return;
    if (target.dataset.min == null && target.min == null) return;
    if (target.dataset.index == null && target.dataset.line == null) return;

    const inputValue = parseInt(target.value, 10);
    const index = target.dataset.index || target.dataset.line;
    const minValue = parseInt(target.dataset.min || target.min || '1', 10) || 1;
    const maxValue = parseInt(target.max, 10);
    const stepValue = parseInt(target.step || '1', 10) || 1;

    if (Number.isNaN(inputValue)) return;

    if (inputValue < minValue) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', String(minValue)));
    } else if (!Number.isNaN(maxValue) && inputValue > maxValue) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', String(maxValue)));
    } else if (inputValue % stepValue != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', String(stepValue)));
    } else {
      target.setCustomValidity('');
      target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

// API 配置
window.API_CONFIG = {
  // 是否启用代理模式（设为true启用代理，false直接调用）
  USE_PROXY: false,
  // 代理路径前缀 - 可以指向外部代理服务器
  PROXY_PATH: '/api/proxy',

  // 直接调用时的API基础URL
  DIRECT_BASE_URL: window.API_BASE_URL
};

// API 请求封装函数
window.apiRequest = async function (path, payload = null) {
  try {

    let url;
    const options = {
      method: payload ? 'POST' : 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en'
      }
    };

    if (payload) {
      options.body = JSON.stringify(payload);
    }

    if (window.API_CONFIG.USE_PROXY) {
      // 使用代理模式
      url = `${window.API_CONFIG.PROXY_PATH}${path}`;
    } else {
      // 直接调用模式
      let baseUrl = window.API_BASE_URL || window.API_CONFIG.DIRECT_BASE_URL;

      // 保持 HTTPS，不再做协议降级
      if (baseUrl && baseUrl.startsWith('//')) {
        baseUrl = 'https:' + baseUrl;
      }

      // 拼接URL，避免双斜杠或缺少斜杠
      if (baseUrl.endsWith('/') && path.startsWith('/')) {
        url = baseUrl + path.substring(1);
      } else if (!baseUrl.endsWith('/') && !path.startsWith('/')) {
        url = baseUrl + '/' + path;
      } else {
        url = baseUrl + path;
      }
    }


    const response = await fetch(url, options);

    if (!response.ok) {
      let errorMessage = response.statusText;
      try {
        const errorData = await response.clone().json();
        if (errorData && errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // 如果解析 JSON 失败（例如返回了 HTML），降级使用 statusText
      }
      // 手动抛出错误，以便统一在下方的 catch 块中处理
      throw new Error(errorMessage);
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    // 这里 catch 会捕获三种情况：
    // 1. 网络故障（断网、DNS失败），fetch 会直接抛出错误
    // 2. HTTP 错误（404, 500等），由上方 if (!response.ok) 手动抛出
    // 3. 数据解析错误，例如 response.json() 失败
    console.error('API Request failed:', error);
    return { success: false, error: error.message };
  }
};

// 字符串转驼峰命名工具函数
function toCamelCase(str) {
  return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
}

// 全局埋点函数
window.trackClick = async function (eventName, params = {}) {
  try {
    if (window.apiRequest) {
      // 将参数转换为驼峰命名并包装在 params 对象中
      const formattedParams = {};
      Object.keys(params).forEach(key => {
        // 排除 link 参数
        if (key !== 'link') {
          const camelKey = toCamelCase(key);
          formattedParams[camelKey] = params[key];
        }
      });
      
      // 不使用 await 阻塞，允许请求在后台静默发出，避免影响主要交互（如弹出购物车）
      window.apiRequest('/user/event/click', {
        eventName: eventName,
        params: formattedParams
      }).catch(err => {
        // 静默捕获埋点请求错误
      });
    }
  } catch (error) {
    console.error('Tracking error:', error);
  }
};

// Shared transport retry. Keep the same promise pending so callers retain loading UI.
(function installFetchRetry() {
  if (window.fetchWithRetry) return;
  const nativeFetch = window.fetch.bind(window);
  window.fetchWithRetry = async function (input, options = {}) {
    const { timeoutMs = 20000, ...init } = options;
    const method = String(init.method || (typeof Request !== 'undefined' && input instanceof Request ? input.method : 'GET')).toUpperCase();
    const read = method === 'GET' || method === 'HEAD';
    // Writes and token rotation must never be replayed after an uncertain outcome.
    const url = typeof input === 'string' ? input : input.url || String(input);
    if (!read || /\/authority\/account\/token\/refresh(?:[?#]|$)/.test(url)) return nativeFetch(input, init);
    const signal = init.signal === undefined ? input.signal : init.signal;
    const checkAbort = () => { if (signal?.aborted) throw signal.reason || new DOMException('Aborted', 'AbortError'); };
    for (let attempt = 0; ; attempt++) {
      checkAbort();
      const controller = new AbortController();
      let timedOut = false;
      let httpFailure = false;
      const abort = () => controller.abort(signal.reason);
      signal?.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(() => {
        timedOut = true;
        controller.abort(new DOMException('Request timed out', 'TimeoutError'));
      }, timeoutMs);
      try {
        // HTTP and business failures are handled by existing callers, without retry.
        const response = await nativeFetch(input, { ...init, signal: controller.signal });
        httpFailure = response.ok === false;
        // Fetch resolves at headers. Keep timeout/cancellation active until the
        // body arrives too; leave the original Response readable for callers.
        if (response.body) await response.clone().arrayBuffer();
        return response;
      } catch (error) {
        checkAbort();
        if (httpFailure || attempt >= 2 || (!timedOut && error?.name !== 'TypeError' && error?.name !== 'TimeoutError')) throw error;
      } finally {
        clearTimeout(timer);
        signal?.removeEventListener('abort', abort);
      }
      await new Promise((resolve, reject) => {
        const abortWait = () => {
          clearTimeout(wait);
          signal?.removeEventListener('abort', abortWait);
          reject(signal.reason || new DOMException('Aborted', 'AbortError'));
        };
        const wait = setTimeout(() => {
          signal?.removeEventListener('abort', abortWait);
          resolve();
        }, 500 * 2 ** attempt);
        signal?.addEventListener('abort', abortWait, { once: true });
        if (signal?.aborted) abortWait();
      });
    }
  };
})();

// 全局 401 和 500 拦截器（安装一次）
(function installFetch401Interceptor() {
  if (window.__fetch401Installed) return;
  window.__fetch401Installed = true;

  let isRefreshing = false;
  let refreshQueue = [];

  const originalFetch = window.fetchWithRetry;
  window.fetch = async function (...args) {
    let response;
    const configuredApiBase = String(window.API_BASE_URL || '').replace(/\/$/, '');
    try {
      try {
        const requestUrl = args[0] || '';
        const urlString =
          typeof requestUrl === 'string'
            ? requestUrl
            : (requestUrl && requestUrl.url) || '';

        const shouldAttachAuthHeaders = (() => {
          if (!urlString) return false;
          if (urlString.includes('section_id=')) return false;
          const isHttpLocalRequest = /^http:\/\//i.test(urlString);
          let pathname = '';
          try {
            pathname = new URL(urlString, window.location.origin).pathname || '';
          } catch (e) {
            pathname = urlString.startsWith('/') ? urlString : '';
          }
          const isWebApiPath = /^\/web\//.test(pathname);
          const isConfiguredApiRequest =
            !!configuredApiBase &&
            isHttpLocalRequest &&
            (urlString === configuredApiBase || urlString.startsWith(configuredApiBase + '/'));
          const isLocalDirectApiPath =
            isConfiguredApiRequest && /^(\/authority\/|\/user\/)/.test(pathname);
          if (!(isWebApiPath || isLocalDirectApiPath)) return false;
          // if (pathname.includes('/authority/account/token/refresh')) return false;  我觉得不用
          return true;
        })();

        if (shouldAttachAuthHeaders) {
          const init = args[1] || {};
          const existingHeaders = init.headers;
          const mergedHeaders = new Headers(existingHeaders || {});

          const accessToken =
            window.authAPI && typeof window.authAPI.getAccessToken === 'function'
              ? window.authAPI.getAccessToken()
              : '';
          const refreshToken =
            window.authAPI && typeof window.authAPI.getRefreshToken === 'function'
              ? window.authAPI.getRefreshToken()
              : '';

          const inferRegion = () => {
            try {
              // 1. Check URL or hostname
              const host = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : '';
              const path = (window.location && window.location.pathname) ? window.location.pathname.toLowerCase() : '';

              // Canada uses /en-ca under the Singapore store, before the SG host fallback.
              if (window.getMarketCode && window.getMarketCode() === 'ca') return 'SG';
              
              // UK Market (Live & Test)
              if (host.includes('uk.strutt.inc') || (host.includes('sy10cy-bd.myshopify.com') && isUkPrefixedPath(path)) || isUkPrefixedPath(path)) return 'UK';
              
              // EU Market (Live & Test)
              if (host.includes('eu.strutt.inc') || (host.includes('sy10cy-bd.myshopify.com') && isEuPrefixedPath(path)) || isEuPrefixedPath(path)) return 'EU';
              
              // SG Market (Live & Test)
              if (host.includes('321eeeus.myshopify.com') || (host.includes('strutt.inc') && !host.includes('uk.strutt.inc') && !host.includes('eu.strutt.inc'))) return 'SG';

              // US Market (Live & Test)
              if (host.includes('strutt.us') || host.includes('gfhpc0-p9.myshopify.com')) return 'US';
              
          

              // 2. Fallback to navbar buttons
              const regionButtons = document.querySelectorAll('.component-navbar__region-btn, .component-navbar__region-label');
              let regionText = '';
              regionButtons.forEach((btn) => {
                if (regionText) return;
                if (!btn || !btn.textContent) return;
                const style = window.getComputedStyle(btn);
                if (style && style.display === 'none') return;
                regionText = btn.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
              });
              if (regionText === 'US') return 'US';
              if (regionText === 'UK') return 'UK';
              if (regionText === 'EU') return 'EU';
              if (regionText === 'SG') return 'SG';

            } catch (e) {}
            return 'US';
          };

          if (!mergedHeaders.has('X-Client-Type')) {
            mergedHeaders.set('X-Client-Type', 'web');
          }
          if (typeof window.getMarketCode === 'function' && window.getMarketCode() === 'ca') {
            mergedHeaders.set('Accept-Language', 'CA');
            mergedHeaders.set('X-Site-Region', 'SG');
          } else if (!mergedHeaders.has('Accept-Language')) {
            mergedHeaders.set('Accept-Language', window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en');
          }
          if (accessToken && !mergedHeaders.has('Authorization')) {
            mergedHeaders.set('Authorization', `Bearer ${accessToken}`);
          }
          if (refreshToken && !mergedHeaders.has('Refresh-token')) {
            mergedHeaders.set('Refresh-token', refreshToken);
          }
          if (!mergedHeaders.has('X-Site-Region')) {
            mergedHeaders.set('X-Site-Region', inferRegion());
          }

          args[1] = { ...init, headers: mergedHeaders };
        }
      } catch (e) {
      }

      response = await originalFetch(...args);
    } catch (error) {
      // 网络错误（如下线、DNS 解析失败等）
      if (window.showToast) {
        // window.showToast('Network error, please try again.', 'error', 3000);
      }
      // 将错误“原样抛回”给调用者，让调用 fetch 的地方（如 apiRequest）也能感知到失败并进入它的 catch 逻辑
      throw error;
    }

    try {
      
      if (response) {
        // 处理 503 和 504 错误
        if (response.status === 503 || response.status === 504) {
          try {
            const clone = response.clone();
            const data = await clone.json();
            
            // 只有当 message 包含特定关键词时才拦截并弹窗
            if (data && data.message) {
              const msg = data.message;
              let shouldShowToast = false;
              let toastMessage = msg; // 默认直接显示后端返回的 message

              // 匹配 ConnectException
              if (response.status === 503 && msg.includes('Network connection error')) {
                shouldShowToast = true;
              }
              // 匹配 TimeoutException
              else if (response.status === 504 && msg.includes('Request timeout')) {
                shouldShowToast = true;
              }

              if (shouldShowToast && window.showToast) {
                window.showToast(toastMessage, 'error', 3000);
                return response;
              }
            }
          } catch (e) {
            // 解析失败（非 JSON），不处理，让其继续向下流转
          }
        }

        // 获取请求URL
        // 获取请求URL
        const requestUrl = args[0] || '';
        const urlString = typeof requestUrl === 'string' ? requestUrl : (requestUrl.url || '');
        const isHttpLocalRequest = /^http:\/\//i.test(urlString);

        const isWebApi =
          /\/web\//.test(urlString) ||
          (!!configuredApiBase &&
            isHttpLocalRequest &&
            (urlString === configuredApiBase || urlString.startsWith(configuredApiBase + '/')) &&
            /^(\/authority\/|\/user\/)/.test(
              (() => {
                try {
                  return new URL(urlString, window.location.origin).pathname || '';
                } catch (e) {
                  return '';
                }
              })()
            ));
        const isRefreshApi = urlString.includes('/authority/account/token/refresh');
        // Redemption is a user-confirmed write. Never refresh and replay it or
        // enqueue it behind another refresh; let the points UI report failure.
        const isPointsRedemption = /\/points-center\/points\/redeem\/?$/.test(
          new URL(urlString, window.location.origin).pathname
        );

        if (!isWebApi || isPointsRedemption) {
          return response;
        }

          // Check response message before processing session expiry
          const clone = response.clone();
          try {
            const data = await clone.json();

            if (isRefreshApi) {
              if (data.code == 500) {
                if (window.authAPI && typeof window.authAPI.clearAllTokens === 'function') {
                  window.authAPI.clearAllTokens();
                }

                if (window.userProfileAPI && typeof window.userProfileAPI.clearCachedUserData === 'function') {
                  window.userProfileAPI.clearCachedUserData();
                }

                setTimeout(() => {
                  sessionStorage.setItem('loginToastMessage', data.message || '');
                  window.location.href = window.withSitePrefix('/pages/login');
                }, 500);
              }

              return response;
            }

            // 2. 处理 401 Token 刷新
            if (data.code == 401 && data.message ) {
              
              if (!isRefreshing) {
                isRefreshing = true;

                try {
                  const refreshResponse = await originalFetch(window.API_BASE_URL + '/authority/account/token/refresh', {
                    method: 'GET',
                    headers: {
                      'Refresh-token': window.authAPI ? window.authAPI.getRefreshToken() : '',
                      'X-Client-Type': 'web',
                      'Accept-Language': window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en'
                    }
                  });

                  const refreshData = await refreshResponse.json();
                  // 如果刷新接口返回数据中 code 为 500 或其他非 200 错误
                  if (refreshData.code !== 200) {
                    throw new Error(refreshData.message || '');
                  }

                  // 刷新成功：更新 Token 并重试队列
                  if (refreshData.code === 200 && refreshData.data) {
                    const accessToken = refreshData.data.accessToken;
                    const refreshToken = refreshData.data.refreshToken;

                    if (window.authAPI) {
                      if (accessToken) window.authAPI.saveAccessToken(accessToken);
                      if (refreshToken) window.authAPI.saveRefreshToken(refreshToken);
                    }

                    isRefreshing = false;

                    // 执行队列中的重试请求
                    refreshQueue.forEach(callback => callback(accessToken, refreshToken));
                    refreshQueue = [];

                    // 重试当前请求
                    const retryOptions = args[1] || {};
                    const retryHeaders = new Headers(retryOptions.headers || {});
                    if (accessToken) {
                      retryHeaders.set('Authorization', `Bearer ${accessToken}`);
                    }
                    if (refreshToken) {
                      retryHeaders.set('Refresh-token', refreshToken);
                    }
                    if (!retryHeaders.has('Accept-Language')) {
                      retryHeaders.set('Accept-Language', window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en');
                    }
                    retryOptions.headers = retryHeaders;
                    return originalFetch(args[0], retryOptions);
                  }

                } catch (error) {
                  isRefreshing = false;
                  // 刷新彻底失败：清除 Token 并跳转登录
                  if (window.authAPI) window.authAPI.clearAllTokens();
                  if (window.userProfileAPI) window.userProfileAPI.clearCachedUserData();
                  // 拒绝队列中的请求
                  refreshQueue = [];
                  
                  // 将错误信息存入 sessionStorage，供登录页面显示
                  sessionStorage.setItem('loginToastMessage', error.message || '');
                  
                  setTimeout(() => {
                    window.location.href = window.withSitePrefix('/pages/login');
                  }, 500);
                  // 中止当前请求，防止后续逻辑报错，等待页面跳转
                  return new Promise(() => {});
                }
              } else {
                // 正在刷新中，将当前请求加入队列等待
                return new Promise((resolve) => {
                  refreshQueue.push((newAccessToken, newRefreshToken) => {
                    const retryOptions = args[1] || {};
                    const retryHeaders = new Headers(retryOptions.headers || {});
                    if (newAccessToken) {
                      retryHeaders.set('Authorization', `Bearer ${newAccessToken}`);
                    }
                    if (newRefreshToken) {
                      retryHeaders.set('Refresh-token', newRefreshToken);
                    }
                    if (!retryHeaders.has('Accept-Language')) {
                      retryHeaders.set('Accept-Language', window.getRequestAcceptLanguage ? window.getRequestAcceptLanguage() : 'en');
                    }
                    retryOptions.headers = retryHeaders;
                    resolve(originalFetch(args[0], retryOptions));
                  });
                });
              }
            }

            
          } 
          catch (e) {
            // Ignore JSON parse errors
          }
        }
    } catch (e) {
      // 拦截器自身稳健性
      console.warn('401/500 interceptor error:', e);
    }

    return response;
  };
})();

/*
使用示例：

// 1. 使用简化的 showSimpleError 函数（推荐）
window.showSimpleError('Email format incorrect, please try again.', errorContainer);

// 2. 使用完整的 showError 函数（需要自定义配置时）
window.showError('Email format incorrect, please try again.', errorContainer, {
  className: 'custom-error',
  marginTop: '8px',
  inputClass: 'email-input'
});

// 3. 隐藏错误信息
window.hideSimpleError(); // 隐藏简单错误
window.hideError('custom-error'); // 隐藏自定义错误

默认配置：
- marginTop: '4px'
- marginLeft: '16px'
- color: var(--function-error, #FFB4AB)
- fontFamily: "STRUTT Modena 370"
- fontSize: var(--Caption-C1_fixed, 14px)
- fontStyle: normal
- fontWeight: 300
- lineHeight: 150%
*/

} // 结束 global.js 重复执行保护
